/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { conversationIndex } from '../../axios/conversationIndex'
import type { ConversationIndexError, ConversationIndexResponse } from '../../types/ConversationIndex'

export const conversationIndexQueryKey = () => [{ url: '/ai/conversations' }] as const

export type ConversationIndexQueryKey = ReturnType<typeof conversationIndexQueryKey>

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::index */
export function conversationIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		ConversationIndexResponse,
		AxiosError<ConversationIndexError>,
		ConversationIndexResponse,
		ConversationIndexQueryKey
	>({
		queryKey: conversationIndexQueryKey(),
		queryFn: ({ signal }) => conversationIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::index */
export function useConversationIndex<TSelectData = ConversationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ConversationIndexResponse,
					AxiosError<ConversationIndexError>,
					TSelectData,
					ConversationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ConversationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...conversationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::index */
export function useConversationIndexSuspense<TSelectData = ConversationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ConversationIndexResponse,
					AxiosError<ConversationIndexError>,
					TSelectData,
					ConversationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ConversationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...conversationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
